import React from 'react'
import EnthChart from './BarChart'


const BarChartContainer = (props) => {
    return <EnthChart barChartDetails={props.barChartDetails} barChartValues={props.barChartValues} chartWidth={props.chartWidth}/>
}

export default BarChartContainer